import React from 'react';
import { Route, Switch, HashRouter, Redirect } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import './index.css';
import Error from './Error/error404.js';
import store from "./store/store.js";
import LoginAction from './store/action/LoginAction.js';
import HomeAction from './store/action/HomeAction.js';
import ShouyeAction from './store/action/ShouyeAction.js';
import HetongAction from './store/action/HetongAction.js';
import HetongCsAction from './store/action/HetongCsAction.js';
import FangjianAction from './store/action/FangjianAction.js';
import PingmiantuAction from './store/action/PingmiantuAction.js';
import Jf_fzAction from './store/action/Jf_fzAction.js';
import Jf_wyfAction from './store/action/Jf_wyfAction.js';
import Jf_sfAction from './store/action/Jf_sfAction.js';
import Jf_dfAction from './store/action/Jf_dfAction.js';
import Jf_zlfAction from './store/action/Jf_zlfAction.js';
import Jf_gnfAction from './store/action/Jf_gnfAction.js';
import Jf_csfAction from './store/action/Jf_csfAction.js';
import Jf_fwfAction from './store/action/Jf_fwfAction.js';
import QiyeAction from './store/action/QiyeAction.js';
import CaigouAction from "./store/action/CaigouAction";
import UserAction from "./store/action/UserAction";
import CzjlAction from "./store/action/CzjlAction";
import BackupAction from "./store/action/BackupAction";
import SettingAction from "./store/action/SettingAction";
import GerenAction from "./store/action/GerenAction";
import MmxgAction from "./store/action/MmxgAction";
import SjtjAction from "./store/action/SjtjAction";
import ZtxmAction from "./store/action/ZtxmAction";
import ChanfangAction from "./store/action/ChangfangAction";
import OfficeAction from "./store/action/OfficeAction";
import MiniHome from "./miniHome/index.js";




class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 1, route: [], // isLogin: store.getState().data.isLogin ? store.getState().data.isLogin : false,
        }
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data)
            // if(store.getState().data.info.qx){
            //     var route = []
            //     if(store.getState().data.info.qx.includes('1')){

            //     }
            // }
        })
    }

    componentDidMount() {
        // this.props.IS_MOBILE();
        // let isLogin = store.getState().data.isLogin ? store.getState().data.isLogin : false
        // console.log(isLogin)
    }

    Shouye() {
        let route = [<Route exact path="/" component={ShouyeAction} />,]
        return route
    }

    Hetong() {
        let route = [<Route exact path="/hetong" component={HetongAction} />,]
        return route
    }

    HetongCs() {
        let route = [<Route exact path="/hetong_cs" component={HetongCsAction} />,]
        return route
    }

    Fangjian() {
        let route = [
            <Route exact path="/fangjian" component={FangjianAction} />,
            <Route exact path="/pingmiantu" component={PingmiantuAction} />,
        ]
        return route
    }

    Jf_fz() {
        let route = [<Route exact path="/jf_fz" component={Jf_fzAction} />,]
        return route
    }

    Jf_wyf() {
        let route = [<Route exact path="/jf_wyf" component={Jf_wyfAction} />,]
        return route
    }

    Jf_sf() {
        let route = [<Route exact path="/jf_sf" component={Jf_sfAction} />,]
        return route
    }

    Jf_df() {
        let route = [<Route exact path="/jf_df" component={Jf_dfAction} />,]
        return route
    }

    Jf_zlf() {
        let route = [<Route exact path="/jf_zlf" component={Jf_zlfAction} />,]
        return route
    }

    Jf_gnf() {
        let route = [<Route exact path="/jf_gnf" component={Jf_gnfAction} />,]
        return route
    }
    Jf_csf() {
        let route = [<Route exact path="/jf_csf" component={Jf_csfAction} />,]
        return route
    }
    Jf_fwf() {
        let route = [<Route exact path="/jf_fwf" component={Jf_fwfAction} />,]
        return route
    }

    Qiye() {
        let route = [<Route exact path="/qiye" component={QiyeAction} />,]
        return route
    }

    Caigou() {
        let route = [<Route exact path="/caigou" component={CaigouAction} />,]
        return route
    }

    User() {
        let route = [<Route exact path="/user" component={UserAction} />,]
        return route
    }

    Czjl() {
        let route = [<Route exact path="/czjl" component={CzjlAction} />,]
        return route
    }

    Backup() {
        let route = [<Route exact path="/backup" component={BackupAction} />,]
        return route
    }

    Setting() {
        let route = [<Route exact path="/setting" component={SettingAction} />,]
        return route
    }

    Geren() {
        let route = [<Route exact path="/geren" component={GerenAction} />,]
        return route
    }

    Mmxg() {
        let route = [<Route exact path="/mmxg" component={MmxgAction} />,]
        return route
    }

    Sjtj() {
        let route = [<Route exact path="/sjtj" component={SjtjAction} />,]
        return route
    }

    Ztxm() {
        let route = [<Route exact path="/ztxm" component={ZtxmAction} />,]
        return route
    }

    Office() {
        let route = [<Route exact path="/office" component={OfficeAction} />,]
        return route
    }
    Chanfang() {
        let route = [<Route exact path="/changfang" component={ChanfangAction} />,]
        return route
    }



    render() {
        let isLogin = store.getState().data.isLogin ? store.getState().data.isLogin : false
        const domain = window.location.origin;
        return (<ConfigProvider locale={zhCN}>
            <HashRouter>
                <Switch>
                    <Route exact path="/login" component={LoginAction} />
                    <Route exact path="/miniHome" component={MiniHome} />
                    <HomeAction>
                        <Switch>
                            {this.Shouye()}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('1') ? this.Hetong() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('102') ? this.HetongCs() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('2') ? this.Fangjian() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('301') ? this.Jf_fz() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('302') ? this.Jf_wyf() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('303') ? this.Jf_sf() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('304') ? this.Jf_df() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('305') ? this.Jf_zlf() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('306') ? this.Jf_gnf() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('307') ? this.Jf_csf() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('308') ? this.Jf_fwf() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('4') ? this.Qiye() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('5') ? this.Caigou() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('6') ? this.User() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('7') ? this.Czjl() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('8') ? this.Setting() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('9') ? this.Backup() : null) : null}
                            {this.Geren()}
                            {this.Mmxg()}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('11') ? this.Sjtj() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('12') ? this.Ztxm() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('131') ? this.Chanfang() : null) : null}
                            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('132') ? this.Office() : null) : null}
                            <Route path="*" component={Error} />
                        </Switch>
                    </HomeAction>
                </Switch>
            </HashRouter>
        </ConfigProvider>);
    }
}

export default App;
